import { storage } from '../../services/StorageService';
import { classColor } from '../../ui/theme/colors';
import { NAMEPLATE } from '../../../shared/config/nameplate.config';

/**
 * Settings → Interface "Class-coloured names" (UserPrefs ui.classTintNames,
 * plan 23 row 34, lane BO). Off by default: a red warrior name read as
 * "hostile" (lane BM). When on, other players' overhead names take their
 * calling's class colour, lifted toward white so the darker callings stay
 * readable on night maps while the black stroke carries them on light ones.
 * Your own name keeps the parchment ink.
 *
 * One cached value kept fresh by one prefs subscription — no localStorage
 * parse per frame (same shape as overheadNamesPref).
 */

/** Share of white mixed into the class colour for the name fill. */
export const CLASS_NAME_LIFT = 0.35;

let cached: boolean | null = null;
let subscribed = false;

export function getClassTintNames(): boolean {
  if (cached === null) {
    try {
      cached = storage.loadUserPrefs().ui.classTintNames;
      if (!subscribed) {
        subscribed = true;
        storage.subscribeUserPrefs((p) => { cached = p.ui.classTintNames; });
      }
    } catch {
      cached = false; // storage unavailable (tests, private window)
    }
  }
  return cached;
}

export function setClassTintNames(on: boolean): void {
  const cur = storage.loadUserPrefs();
  storage.saveUserPrefs({ ...cur, ui: { ...cur.ui, classTintNames: on } });
  cached = on;
}

/** The overhead name fill for a player: parchment ink, or the lifted class colour. */
export function overheadNameColor(calling: string | undefined, tinted: boolean): number {
  if (!tinted || !calling) return NAMEPLATE.name.color;
  const rgb = parseInt(classColor(calling).slice(1), 16);
  const lift = (shift: number) => {
    const c = (rgb >> shift) & 0xff;
    return Math.round(c + (255 - c) * CLASS_NAME_LIFT) << shift;
  };
  return lift(16) | lift(8) | lift(0);
}

/** Test hook. */
export function __resetClassTintNamesForTesting(on: boolean | null = null): void {
  cached = on;
}
